module.exports = __webpack_public_path__ + "static/media/pic4.8f3fa83b.jpg";